
# 桌面通知相关

window.tower ||= {}

tower.d18n =
  support: ->
    window.Notification?

  permitted: ->
    return false unless tower.d18n.support()
    return Notification.permission is 'granted'

  requestPermission: ->
    return  unless tower.d18n.support()
    Notification.requestPermission () ->

  show: (n) ->
    return  unless tower.d18n.support()
    # NOTE: https://tower.im/teams/630713/todos/9654#01b64ec901a0295557ae7e5d6e58aefe
    if /Mac.*Chrome/.test navigator.userAgent
      notification = new Notification n.title,
        body: n.content
        icon: if window.Bridge then false else "#{process.env.OSS_ASSETS_ENDPOINT}/icon-tower.png"
        silent: true
    else
      notification = new Notification n.title,
        body: n.content
        icon: if window.Bridge then false else "#{process.env.OSS_ASSETS_ENDPOINT}/icon-tower.png"
        tag: n.replaceId
        renotify: true
        silent: true

    notification.onclick = ->
      tower.stack.load n.url,
        root: true
        parent:
          name: '全部通知'
          url: "/teams/#{ n.team }/notifications/"

      window.focus()
      @close()

    notification.onshow = ->
      audio = document.querySelector('#notification-audio')
      return if !audio || tower.d18n_muted
      promise = audio.play()
      # In browsers that don’t yet support this functionality, promise won’t be defined.
      return if promise == undefined
      promise.then( ->
        # Automatic playback started!
      ).catch (error) ->
        # Automatic playback failed.

